import type { FieldValue, IRecord, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Основа повної форми нового, ще не збереженого запису (прототип v4 createRecord): без ідентифікатора; номер — очікуваний наступний
 * (`code`, показ «ПРЕФІКС-номер»; без нього — 0 і порожнє позначення); назва й статус — з наперед заданих значень (статус — лише відомий
 * типу, інакше початковий), теги — так само, решта (виконавець, напрям, ітерація, ранг, доріжка дошки) — у значеннях. Чиста функція.
 */
export function draftRecord(rt: Pick<IRecordTypeDefinition, 'key' | 'statuses' | 'prefix'>, moduleKey: string, values: Record<string, unknown>, now: string, code?: number | null): IRecord {
  const { title, status, tags, ...rest } = values;
  const initial = rt.statuses.initial ?? rt.statuses.list[0]?.value ?? '';
  const known = typeof status === 'string' && rt.statuses.list.some((s) => s.value === status);
  const current = known ? (status as string) : initial;
  return {
    id: '', recordType: rt.key, module: moduleKey, code: code && code > 0 ? code : 0, display: code && code > 0 ? `${rt.prefix}-${code}` : '', title: typeof title === 'string' ? title : '', status: current,
    isClosed: Boolean(rt.statuses.list.find((s) => s.value === current)?.closed), values: rest as Record<string, FieldValue | undefined>, ext: {},
    tags: Array.isArray(tags) ? tags.map(String) : [], visibility: 'workspace', counts: null, permissions: null, createdAt: now, updatedAt: now, rowVersion: 0,
  };
}
